import React from "react";
import { Modal } from "react-bootstrap";

export default function BsModal(props) {
  let size = "lg";
  if (props.xl) size = "xl";
  if (props.sm) size = "sm";
  return (
    <Modal
      size={size}
      show={props.show}
      onHide={props.onClose}
      centered={props.center}
      className={props.className}
    >
      <Modal.Body>{props.children}</Modal.Body>
    </Modal>
  );
}
